import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Alert
} from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const WelcomePage = () => {
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check for OAuth callback parameters
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const refresh = urlParams.get('refresh');
    const errorParam = urlParams.get('error');

    if (errorParam) {
      // Handle OAuth error
      setError(decodeURIComponent(errorParam));
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (token && refresh) {
      // Handle OAuth callback
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refresh);
      // Reload the page to trigger auth state update
      window.location.href = '/dashboard';
    }
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Error Display */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 4 }}
          onClose={() => setError(null)}
        >
          <Typography variant="h6" gutterBottom>
            Authentication Error
          </Typography>
          <Typography variant="body2">
            {error}
          </Typography>
        </Alert>
      )}

      <Box textAlign="center" mb={6}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          DataHive
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Connect your social media accounts and get powerful analytics insights
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Track your performance across multiple platforms, analyze engagement trends, 
          and make data-driven decisions to grow your social media presence.
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ p: 4, mb: 6, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Get Started
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          First, sign in with your Google account to create your dashboard
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={loginWithGoogle}
          sx={{ 
            mt: 2,
            backgroundColor: '#4285f4',
            '&:hover': {
              backgroundColor: '#3367d6',
            }
          }}
        >
          Sign in with Google
        </Button>
      </Paper>

      <Box textAlign="center" mt={6}>
        <Typography variant="body2" color="text.secondary">
          Secure OAuth authentication • Your data stays private • No passwords required
        </Typography>
      </Box>
    </Container>
  );
};

export default WelcomePage;
